import { useOutletContext } from "react-router";

export interface AiTabContext {
  orgId: string | undefined;
}

export function useAiTabContext(): AiTabContext {
  return useOutletContext<AiTabContext>();
}
